import React from "react";
import { DuunariPhone, PomoPhone } from "./PhoneMockups";
import { HazardConnector } from "./HazardConnector";
import { GhostCluster } from "./GhostPhone";
import { useLanguage } from "../i18n/LanguageContext";

export const Workflow = () => {
  const { t } = useLanguage();
  return (
    <section id="tyonkulku" data-testid="workflow-section" className="relative py-24 md:py-32 border-t-2 border-[#1a1a1a] grain overflow-hidden">
      <div className="absolute top-8 left-5 md:left-10 font-mono text-[10px] tracking-[0.3em] text-[#A3A3A3] uppercase">{t("workflow.section_number")}</div>
      <div className="absolute top-8 right-5 md:right-10 font-mono text-[10px] tracking-[0.3em] text-[#FFEA00] uppercase">DUUNARI ↔ POMO</div>

      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <div className="text-center mb-20">
          <div className="inline-flex items-center gap-2 mb-5 px-3 py-1.5 border-2 border-[#1f1f1f] bg-black">
            <span className="w-1.5 h-1.5 bg-[#FFEA00] pulse-dot" />
            <span className="font-mono text-[10px] tracking-[0.25em] text-[#A3A3A3] uppercase">{t("workflow.eyebrow")}</span>
          </div>
          <h2 data-testid="workflow-heading" className="font-display font-bold text-white text-4xl md:text-6xl lg:text-7xl uppercase leading-none tracking-tight">
            {t("workflow.heading_line1")}
            <br />
            <span className="text-[#FFEA00]">{t("workflow.heading_line2_accent")}</span>{t("workflow.heading_line2_suffix")}
          </h2>
          <p className="mt-6 max-w-2xl mx-auto text-[#A3A3A3] text-base md:text-lg">{t("workflow.subline")}</p>
        </div>

        <div className="relative flex flex-col lg:flex-row items-center justify-center gap-0 pt-12">
          <div className="relative float-soft lg:-mr-2 xl:-mr-1" style={{ zIndex: 2 }}>
            <GhostCluster side="left" />
            <div className="relative" style={{ zIndex: 2 }}><DuunariPhone /></div>
          </div>
          <div className="relative" style={{ zIndex: 3 }}><HazardConnector /></div>
          <div className="relative float-soft-delay lg:-ml-2 xl:-ml-1" style={{ zIndex: 2 }}>
            <div className="relative" style={{ zIndex: 2 }}><PomoPhone /></div>
          </div>
        </div>

        <div className="mt-16 grid grid-cols-1 lg:grid-cols-2 gap-6 max-w-4xl mx-auto">
          <FlowCard number="01" title={t("workflow.duunari_title")} description={t("workflow.duunari_desc")} color="white" />
          <FlowCard number="02" title={t("workflow.pomo_title")} description={t("workflow.pomo_desc")} color="yellow" />
        </div>
      </div>
    </section>
  );
};

const FlowCard = ({ number, title, description, color }) => {
  const isYellow = color === "yellow";
  return (
    <div data-testid={`flow-card-${number}`} className={`relative border-2 p-6 bg-[#0a0a0a] ${isYellow ? "border-[#FFEA00]" : "border-[#333]"}`}>
      <div className="flex items-start gap-4">
        <div className={`font-display font-bold text-3xl leading-none ${isYellow ? "text-[#FFEA00]" : "text-[#444]"}`}>{number}</div>
        <div className="flex-1">
          <div className="font-display font-bold text-white text-xl uppercase tracking-wide leading-tight">{title}</div>
          <p className="mt-2 text-sm text-[#A3A3A3] leading-relaxed">{description}</p>
        </div>
      </div>
      <div className={`absolute -top-px -right-px w-3 h-3 ${isYellow ? "bg-[#FFEA00]" : "bg-white"}`} />
    </div>
  );
};
